import React, { useState, useEffect, useContext, useCallback } from "react"
import Context from "../utils/Context"
import ShowMessage from "../components/ShowMessage"
import api from "../api/api"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle, faTrash, faListOl } from '@fortawesome/free-solid-svg-icons'

export default function ModalCollect() {

  const context = useContext(Context)
  const [designations, setDesignations] = useState()
  const [occupied, setOccupied] = useState(0)
  const [collect, setCollect] = useState()
  const [usedPositions, setUsedPositions] = useState([]) // Add state to store used positions
  const [selectValue, setSelectValue] = useState("") // State for the select input

  const [returnPositions, setReturnPositions] = useState(16)

  useEffect(() => {
    usedList()
    setCollect()
    if (context.collect.length === 1 && context.collect[0].position !== 0) {
      setSelectValue(context.collect[0].position)
    }
  }, [context.collect]) // Changed dependency to avoid infinite loop



  const usedList = async () => {

    const findUsed = await api.findUsed({ type: 1 })

    const positions = findUsed?.data?.length > 0 ? findUsed.data[0]?.positions : []
    setUsedPositions(positions) // Store the used positions
    setOccupied(positions.length)
  }

  const clearBufferCollect = async () => {

    try {
      await api.deleteUsed(2)

    } catch (error) {
      context.actions.setMessage({ message: "Erro a limpar", type: "error" })
    }
    context.actions.setMessage({ message: "Buffer limpo!", type: "success" })
  }

  const handleSelectValue = async (event) => {
    const selectedValue = event.target.value
    setSelectValue(selectedValue)

    if (selectedValue === "all") {
      // Handle "all" option - create collect entries for all occupied positions
      const collectValues = usedPositions.map((position, index) => ({
        priority: index + 1,
        position: position,
        missionName: "collect",
        owner: context.robotInfo?.owner ? context.robotInfo.owner : "Generic",
        robotName: context.robotInfo?.name ? context.robotInfo.name : "1500PT",
        robotId: context.robotInfo?._id ? context.robotInfo._id : "61c0a9c3b24bdab600ad244c",
        areaId: context.areaId ? context.areaId : "63c5414deed6f2040e7cfe66"
      }))

      context.actions.setCollect(collectValues)
      setCollect(collectValues)
    } else if (selectedValue !== "") {
      // Handle single position selection
      let collectValues = [{
        priority: 1,
        position: Number(selectedValue),
        missionName: "collect",
        owner: context.robotInfo?.owner ? context.robotInfo.owner : "Generic",
        robotName: context.robotInfo?.name ? context.robotInfo.name : "1500PT",
        robotId: context.robotInfo?._id ? context.robotInfo._id : "61c0a9c3b24bdab600ad244c",
        areaId: context.areaId ? context.areaId : "63c5414deed6f2040e7cfe66"
      }]

      context.actions.setCollect(collectValues)
      setCollect(collectValues)
    }
  }



  const save = useCallback(async () => {
    let msg = " "
    let typeMsg = "error"

    var respSave
    let saveValidation


    if (collect !== "") {
      const hasInvalidPosition = collect.some(item => item.position === 0)

      if (hasInvalidPosition) {
        context.actions.setMessage({ message: "É necessário selecionar uma opção de retorno", type: "error" })
        return false
      }

      try {

        //Check looping necessery
        respSave = await api.collectDistributions(collect)

        context.actions.setCollect(collect)

        msg = "Começar retorno"
        typeMsg = "success"

        context.actions.setMessage({ message: msg, type: typeMsg })
        await usedList()

      } catch (error) {
        context.actions.setMessage({ message: "Erro a guardar", type: "error" })
        console.log("Erro", error)
      }

    }

  })



  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>

        <header className="modal-card-head">
          <p className="modal-card-title">Manage Return</p>

          <button
            className="delete"
            aria-label="close"
            onClick={() => context.actions.setModalState({ ...context.modalState, collect: false })}
          ></button>
        </header>

        <section className="modal-card-body">

          <div className="field mb-5">
            <label className="label">Manage Return</label>

            <div className="columns">
              <div className="column">
                <label className="label">
                  <u>
                    Setor
                  </u>
                </label>
                <label className="label">
                  <u>
                    Ocupado </u> :  {occupied} / {returnPositions}
                </label>

              </div>
            </div>



            <div className="field has-addons">

              <p className="control is-expanded">
                <select
                  onChange={handleSelectValue}
                  //selected={distributions[idx].position}
                  style={{ minHeight: "2.5rem" }}
                  value={selectValue}
                >
                  <option value="">Escolher sítio...</option>
                  <option value="all">Occupied</option>
                  {designations && designations.length > 0 && designations.map((m, i) =>
                    <option key={i} value={m?.position}>
                      {m?.description}
                    </option>
                  )}
                </select>
              </p>

            </div>
          </div>


          <ShowMessage />

          <div className="control">
            <button className="button is-success" onClick={save} style={{ marginRight: "1rem" }}>
              Começar Retorno
            </button>

            <button className="button is-outlined" style={{ marginRight: "13rem" }} onClick={clearBufferCollect}>
              Limpar Buffer
            </button>

            <button className="button is-success is-pull-right" onClick={() => context.actions.setModalState({ ...context.modalState, collect: false })}>
              Fechar
            </button>
          </div>

        </section>
      </div >
    </div >
  )


}